// Author LFT
// Date 2020-12-22 10:58:56

class SithMesReportTemplateRole {
constructor({
        id = null,
        templateId = '',
        roleId = '',
        roleName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.templateId = templateId;
    this.roleId = roleId;
    this.roleName = roleName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesReportTemplateRole();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'templateName',
        label: 'label.sith.mst.sithMesReportTemplateRole.grid.templateName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleName',
        label: 'label.sith.mst.sithMesReportTemplateRole.grid.roleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesReportTemplateRole.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    templateIdFilter : "",
    roleIdFilter : "",
    roleNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'templateIdFilter',
        label: 'label.sith.mst.sithMesReportTemplateRole.filter.templateId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesReportTemplate'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleNameFilter',
        label: 'label.sith.mst.sithMesReportTemplateRole.filter.roleName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"roleId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'templateId',
        label: 'label.sith.mst.sithMesReportTemplateRole.entity.templateId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesReportTemplate'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleName',
        label: 'label.sith.mst.sithMesReportTemplateRole.entity.roleName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"roleId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesReportTemplateRole.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesReportTemplateRole, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
